import { DetailPlanStateTypes, DetailPlanActionTypes } from "./DetailPlan.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: DetailPlanStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const DetailPlanReducer = (
  state: DetailPlanStateTypes = INITIAL_STATE,
  action: any
): DetailPlanStateTypes => {
  switch (action.type) {
    case DetailPlanActionTypes.FETCH_ALL_DETAIL_PLAN:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case DetailPlanActionTypes.FETCH_ALL_DETAIL_PLAN_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case DetailPlanActionTypes.FETCH_ALL_DETAIL_PLAN_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case DetailPlanActionTypes.FETCH_ALL_DETAIL_PLAN_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case DetailPlanActionTypes.FETCH_ONE_DETAIL_PLAN:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case DetailPlanActionTypes.FETCH_ONE_DETAIL_PLAN_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case DetailPlanActionTypes.FETCH_ONE_DETAIL_PLAN_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case DetailPlanActionTypes.FETCH_ONE_DETAIL_PLAN_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default DetailPlanReducer;
